/**
 * Helpers for the Client Recip flow. Client-recip mode is a toolbar toggle
 * that can be enabled for any chute — it switches the queue-input from a
 * recip-tag lookup to a free-text client name, and sets the clientRecip
 * flag on the POST so the server stores the typed name.
 */

export function getRecipInputPlaceholder(clientRecipMode: boolean): string {
  return clientRecipMode ? 'Client name...' : 'Recip tag...';
}

export function getAddDisabledTitle(
  yardId: string | null | undefined,
  isAdding: boolean,
): string | undefined {
  if (!yardId) return 'Select a yard on the toolbar first';
  if (isAdding) return 'Adding...';
  return undefined;
}

/**
 * Queue items may carry both `tag` and `clientRecipTag` (the server populates
 * one or the other depending on whether the row was a real recip or a typed
 * client name). Display the typed client name when present, otherwise the
 * recip tag. Centralised so the queue grid and the Select button can't
 * disagree on which one wins.
 */
export function getQueueDisplayName(item: {
  tag?: string | null;
  clientRecipTag?: string | null;
}): string {
  return item.clientRecipTag || item.tag || '';
}
